import { createContext } from "react";

export const FeedbackContext = createContext(null);